import React from 'react';
import Skeleton, { SKELETON_WIDTHS } from 'buyside/components/presentation/Skeleton/skeleton';

import styles from './feedItemStyles.scss';

const FeedItemLoading: React.FC<{ times?: number }> = ({ times = 1 }): React.ReactElement => (
  <>
    {[...Array(times)].map((_e, i) => (
      <div className={styles.feedItem} key={`feed-item-loading-${i}`}>
        <div className={styles.feedItemLoadingHeader}>
          <Skeleton width={SKELETON_WIDTHS.MEDIUM} />
        </div>
        <div className={styles.feedItemLoadingBody}>
          <Skeleton />
          <Skeleton width={SKELETON_WIDTHS.ONE_THIRD} />

          <Skeleton />
          <Skeleton />
          <Skeleton width={SKELETON_WIDTHS.TWO_THIRD} />
        </div>
        <div className={styles.feedItemLoadingActionArea}>
          <Skeleton width={SKELETON_WIDTHS.SMALL} />
          <Skeleton width={SKELETON_WIDTHS.SMALL} />
        </div>
      </div>
    ))}
  </>
);

export default FeedItemLoading;
